import {
    CONFIGURACION_CHANGED,
} from './actions'

let initialState = {
    configuracion: null,
}

export const configuracion = (state = initialState, action) => {
    switch (action.type) {
        case CONFIGURACION_CHANGED:
            let newState= {
                ...action.state,
            };
            return newState;

        default:
            return state;
    }
}




